<template>
  <v-card class="my-agents-notification-card">
    <v-card-text class="px-0 pt-0">
      <v-tabs v-model="activeTab" class="my-agents-notifications-tabs-bar" grow>
        <v-tab key="agents" ripple color="black" class="text-none">
          Agents
        </v-tab>
      </v-tabs>
      <v-window v-if="loading">
        <v-window-item>
          <v-row class="mt-8 align-center justify-center">
            <v-col>
              <div style="width: 100%; min-height: 420px">
                <v-row class="align-center justify-center">
                  <v-progress-circular
                    :size="85"
                    :width="8"
                    color="primary"
                    indeterminate
                  />
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-window-item>
      </v-window>
      <v-window v-else-if="!loading && !loadingError">
        <v-window-item>
          <v-row class="pt-4">
            <v-col cols="12" class="pl-6 ml-4">
              <span class="last-24-header">Last 24 hours</span>
            </v-col>
            <v-col
              v-for="n in agentNotifications"
              :key="n.id"
              cols="12"
              class="py-2 px-6"
            >
              <agent-detail-notification-card
                display-type="all-agents-notifications"
                :notification="n"
                @clicked="notificationClicked"
              />
            </v-col>
            <v-col
              v-if="agentNotifications.length === 0"
              cols="12"
              class="px-2"
            >
              <dialog-error
                icon="fa-solid fa-clock-rotate-left"
                icon-color="primary"
                message="No notifications in the past 24 hours"
                class="py-4"
              />
            </v-col>
            <v-col cols="12" class="text-center px-2">
              <v-btn
                color="primary"
                variant="flat"
                :ripple="{ class: 'text-white' }"
                @click="viewAllNotifications"
              >
                <v-icon class="mr-4" color="white" right
                  >fa-solid fa-cloud-arrow-up</v-icon
                >
                <span class="text-none text-white" style="padding-right: 16px"
                  >View All Notifications</span
                >
              </v-btn>
            </v-col>
          </v-row>
        </v-window-item>
      </v-window>
      <v-window v-else>
        <v-window-item class="pt-4">
          <v-row align-center justify-center class="pt-2" fill-height>
            <dialog-error
              message="An error occurred loading agents notifications."
            />
          </v-row>
        </v-window-item>
      </v-window>
    </v-card-text>
  </v-card>
</template>

<script>
import api from "@/services/api.js";

import AgentDetailNotificationCard from "@/components/console/agent-details/AgentDetailNotificationCard";
import { defineAsyncComponent } from "vue";

export default {
  name: "MyNotificationsQuickList",
  components: {
    AgentDetailNotificationCard,
    DialogError: defineAsyncComponent(
      () => import("@/components/console/dialog/DialogError"),
    ),
  },
  data() {
    return {
      loading: false,
      loadingError: false,
      activeTab: null,
      agentNotifications: [],
    };
  },
  methods: {
    async loadAgentsNotifications() {
      this.loading = true;
      this.loadingError = false;

      let fromDate = new Date();
      fromDate.setDate(fromDate.getDate() - 1);

      try {
        let params = {
          pageIndex: 0,
          pageSize: 24,
          sort: "sent,DESC",
          fromDate: fromDate.toISOString().split("T")[0],
        };
        let { data } = await api.agent.getNotifications(params);

        if (data.content) {
          this.agentNotifications = data.content;
          this.loading = false;
          this.loadingError = false;
        }
      } catch (e) {
        this.errorCheck(e);
        this.loading = false;
        this.loadingError = true;
      }
    },
    viewAllNotifications() {
      this.$router.push({
        name: "my-notifications",
      });
    },
    notificationClicked(notification) {
      if (notification.agentId) {
        let query = {
          tab: "notifications",
        };

        if (notification.type === "OVERDUE_REFERRAL_REMINDER") {
          query.tab = "referrals";

          if (
            !notification.referralName.includes("& others") &&
            notification.referralId
          ) {
            query.referralId = notification.referralId;
          }
        } else if (notification.referralId) {
          query.tab = "referrals";
          query.referralId = notification.referralId;
        }

        this.$router.push({
          name: "view-my-agent",
          params: {
            id: notification.agentId,
          },
          query: query,
        });
      }
    },
  },
  mounted() {
    this.loadAgentsNotifications();
  },
};
</script>

<style scoped>
.my-agents-notification-card {
  border-radius: 10px;
  max-height: 480px;
  overflow-x: hidden;
  overflow-y: scroll;
  width: 400px;
}
.my-agents-notification-card::-webkit-scrollbar {
  width: 0; /* Remove scrollbar space */
}

.my-agents-notification-card :deep(.v-card__text:first-of-type) {
  padding: 0 0 0 0 !important;
}

.my-agents-notifications-tabs-bar :deep(.v-tabs-bar) {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 20;
  padding: 0 0 0 0 !important;
}

.agents-notifications-container {
  padding-top: 16px !important;
  padding-bottom: 21px !important;
  background-color: #f9f9f9;
}

.broker-notifications-container {
  border-radius: 8px;
}

.last-24-header {
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #6f6f6f;
}

.v-tab--active {
  color: black !important; /* Ensure active tab text is black */
}

/* You might not need to change anything for the indicator if it's already the desired color */
.v-tabs-bar :deep(.v-tab--active::before) {
  background-color: red !important; /* Adjust if necessary */
}

.v-tab--selected :deep(.v-tab__slider) {
  opacity: 1;
  color: #00c8a8;
}
</style>
